import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupRolePermissionDto } from '../models/GroupRole';
import { ProjectGroupRolePermissionDto, ProjectGroupRolePermissionForUpdateDto } from '../models/ProjectGroupRolePermission';
import { BaseService } from './base.service';

@Injectable({providedIn: 'root'})
export class ProjectGroupRolePermissionService extends BaseService {
 

  constructor(private httpClient: HttpClient) {
    super();
  }

  getProjectUserPermissions(projectId: string) : Observable<string[]> {
    return this.httpClient.get<string[]>(`${this.projectGroupRolePermissions}/${projectId}/GetProjectUserPermissions`);
  }

  loadProjectGroupRolePermissions(projectId: any, groupRoleId: any) : Observable<ProjectGroupRolePermissionDto[]>{
    return this.httpClient.get<ProjectGroupRolePermissionDto[]>(`${this.projectGroupRolePermissions}/${projectId}/GetProjectGroupRolePermissions/${groupRoleId}`);
  }

  loadGroupRolePermissions(groupRoleId: any) : Observable<GroupRolePermissionDto[]>{
    return this.httpClient.get<GroupRolePermissionDto[]>(`${this.projectGroupRolePermissions}/GetGroupRolePermissions/${groupRoleId}`);
  }

  createProjectGroupRolePermission(projectGrpRolePermission: ProjectGroupRolePermissionForUpdateDto): Observable<ProjectGroupRolePermissionDto> {
    return this.httpClient.post<ProjectGroupRolePermissionDto>(`${this.projectGroupRolePermissions}`, projectGrpRolePermission);
  }

  updateProjectGroupRolePermission(projectGrpRolePermission: ProjectGroupRolePermissionForUpdateDto): Observable<ProjectGroupRolePermissionForUpdateDto> {
    return this.httpClient.put<ProjectGroupRolePermissionForUpdateDto>(`${this.projectGroupRolePermissions}`, projectGrpRolePermission);
  }

}
